/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/common/http.service';
import { UrlService } from 'src/app/mq/services/url.service';
import { UserService } from './user.service';
import { LogoService } from './logo.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private httpService: HttpService, private urlService: UrlService,private userService:UserService,private logoService:LogoService) {

  }

  generateResults(query:any) {
    return this.httpService.post(this.urlService.generateSql,query);
  }
  login(passcode:string,){
    return this.httpService.post(this.urlService.userLogin,{
       "passcode": passcode,
       "org_id":this.userService.getOrgId()==0?1:this.userService.getOrgId()
    });
  }
  getFaqs(){
    const params = new HttpParams().set('role_id', this.userService.getRoleId());
    return this.httpService.get(this.urlService.faqs, { params });
  }
  getAllConversations(){
    const params = new HttpParams().set('user_id', this.userService.getUserId());
    return this.httpService.get(this.urlService.getConversations, { params });
  }
  getAllMessages(id:string){
    const params = new HttpParams().set('org_id', this.userService.getOrgId()==0?1:this.userService.getOrgId()).set('user_id', this.userService.getUserId(),).set('trainer_mode', this.userService.getTrainerMode(),);
    return this.httpService.get(this.urlService.getAllMessages(id),{params});
  }
  deleteConverastion(conversationId:string){
    const params = new HttpParams().set('user_id', this.userService.getUserId()).set('conversation_id',conversationId);
    return this.httpService.delete(this.urlService.getConversations, { params });
  }
  getStarredQuestions()
  {
    const params = new HttpParams().set('user_id', this.userService.getUserId()).set('org_id', this.userService.getOrgId()==0?1:this.userService.getOrgId());
    return this.httpService.get(this.urlService.starredQuestions, { params });
  }
  addStarredQuestion(question:string|undefined){
    return this.httpService.post(this.urlService.starredQuestions,{
      "user_id": this.userService.getUserId(),
      "org_id":this.userService.getOrgId()==0?1:this.userService.getOrgId()==0?1:this.userService.getOrgId(),
      "question":question
   });
  }
  deleteStarredQuestion(pid:number){
   const url= `${this.urlService.starredQuestions }/${pid}`
    return this.httpService.delete(url);
  }
  getGraph(query:string){
    return this.httpService.post(this.urlService.graph,{
      "sql_query": query,
     
   } );
  }
  deleteAllConversations(){
    const params = new HttpParams().set('user_id', this.userService.getUserId());
    return this.httpService.delete(this.urlService.deleteAllConversations, { params });
  }
  resetPasscode(oldPasscode: any,newPasscode: any){
    return this.httpService.post(this.urlService.resetPasscode,{
      "old_passcode": oldPasscode,
      "new_passcode": newPasscode,
      "org_id": this.userService.getOrgId()==0?1:this.userService.getOrgId(),
      "user_id":this.userService.getUserId()
   });
  }
  sendFeedback(feedBack: any,question: any,query:any,conversationId:any){
    return this.httpService.post(this.urlService.feedback,{
      "feedback": feedBack, "question": question, "sql": query, "conversation_id": conversationId,"user_id":this.userService.getUserId(),"org_id": this.userService.getOrgId()==0?1:this.userService.getOrgId(),
   });
  }
  getTrainedQuestion(){
    const params = new HttpParams().set('org_id', this.userService.getOrgId()==0?1:this.userService.getOrgId());
    return this.httpService.get(this.urlService.trainedQuestions, { params });
  }

  postTrainingData(question:string,sqlQuery:string,prompt:string,feedBack:number){
    return this.httpService.post(this.urlService.trainingData,{
      "question": question,
      "org_schema_id": this.userService.getOrgId()==0?1:this.userService.getOrgId(),
      "sql_query": sqlQuery,
      "promt": prompt,
      "trainer_id":this.userService.getUserId(),
      "feedback":feedBack,
      "is_auto_generated": true
   });
  }
  updateTrainingData(id:number,body:any){

    return this.httpService.put(this.urlService.trainingDataVersion(id),body);
  }
  getTrainingDataVersions(id:number){
    return this.httpService.get(this.urlService.trainingDataVersion(id))
  }
}
